import React from 'react';
import { useAuthProvider, useLogout, useNotify } from 'react-admin';
import { FormValues } from './types';

/**
 * Hook that updates an user's password.
 */
const useUpdatePassword = () => {
  const authProvider = useAuthProvider();
  const notify = useNotify();
  const logout = useLogout();
  const updatePassword = React.useCallback(
    async (values: FormValues) => {
      try {
        await authProvider.changePassword(
          values.old_password,
          values.new_password,
        );
        notify('Password was changed.', 'success');
        logout();
      } catch (error) {
        notify(
          error.message
            ? error.message
            : 'Something goes wrong, please check old password and new password.',
          'error',
        );
      }
    },
    [authProvider, notify, logout],
  );

  return {
    updatePassword,
  };
};

export default useUpdatePassword;
